<p *ngIf="isRegistrationError && registrationErrorMsg" class="alert alert-warning font-weight-bold text-center"><i class="mdi mdi-error"></i>{{registrationErrorMsg}}</p>
<div *ngIf="showSuccessPane && registrationMsg">
  <p class="alert alert-success font-weight-bold text-center"><i class="mdi mdi-error"></i>{{registrationMsg}}</p>
  <p class="text-links-wrap">
    <a routerLink="/access/login" class="text-link">Back to login</a>
    <a routerLink="/access/resendemailverification" class="text-link text-right">Resend verification email</a>
  </p>
</div>
<form *ngIf="!showSuccessPane" [formGroup]="registrationForm" class="m-0" (ngSubmit)="OnSubmit()" autocomplete="off">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" formControlName="email" [disabled]="this.registrationService_.isLoading" required>
    <div class="formError" *ngIf="registrationForm.get('email')?.invalid && registrationForm.get('email')?.touched">
      <span *ngIf="registrationForm.get('email')?.hasError('required')">Email is required</span>
      <span *ngIf="registrationForm.get('email')?.hasError('email')">Enter a valid email</span>
    </div>
  </div>
  <div class="fieldset">   
      <label for="preSelectedCountryCode" class="legend">Phone</label>
      <div>
        <select name="preSelectedCountryCode" class="text-field col-4 d-inline" id="preSelectedCountryCode" formControlName="countrycode"
        [disabled]="this.registrationService_.isLoading" (change)="onCountryCodeChange()" required >
          <option *ngFor="let countryCode of countryCodes" [value]="countryCode.Code">{{countryCode.Country}}: {{countryCode.Code}} </option>
        </select>       
        <input type="tel" name="Phone" id="Phone" class="text-field col-8 d-inline"  formControlName="phone" [disabled]="this.registrationService_.isLoading" required>  
      </div>
      <div class="formError" *ngIf="registrationForm.get('phone')?.invalid && registrationForm.get('phone')?.touched">
        <div *ngIf="registrationForm.get('phone')?.hasError('invalidPhoneNumber')">Invalid phone number format</div>
        <span *ngIf="registrationForm.get('phone')?.hasError('required')">Phone number is required</span>
      </div>
    </div>
  <div class="fieldset">
    <label for="Password" class="legend">Password</label>
    <input type="password" name="Password" id="Password" class="text-field" [disabled]="this.registrationService_.isLoading" formControlName="password" required>
    <div class="formError" *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched">
      <span *ngIf="registrationForm.get('password')?.hasError('required')">Password is required</span>
      <span *ngIf="registrationForm.get('password')?.hasError('minlength')">Password must be at least 8 characters </span>
      <span *ngIf="registrationForm.get('password')?.hasError('maxlength')">Password cannot exceed 64 characters</span>
      <span *ngIf="registrationForm.get('password')?.hasError('pattern')">Password must contain uppercase, lowercase, number and special character</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="CPassword" class="legend">Confirm Password</label>
    <input type="password" name="CPassword" id="CPassword" class="text-field" [disabled]="this.registrationService_.isLoading" formControlName="cpassword" required>
    <div class="formError" *ngIf="registrationForm.get('cpassword')?.invalid && registrationForm.get('cpassword')?.touched">
      <span >Passwords do not match</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="Name" class="legend">Full Name</label>
    <input type="text" name="Name" id="Name" class="text-field" [disabled]="this.registrationService_.isLoading" formControlName="fullname" required>
    <div class="formError" *ngIf="registrationForm.get('fullname')?.invalid && registrationForm.get('fullname')?.touched">
      <span *ngIf="registrationForm.get('fullname')?.hasError('required')">Full-name is required</span>
    </div>
  </div>
  <button *ngIf="!this.registrationService_.isLoading; else isLoading" type="submit" class="btn m-auto" [disabled]="registrationForm.invalid">Register</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Registering...</button>
  </ng-template>
  <div class="fieldset mt-3">
    <p class="text-center text-sm mb-1">Or</p>
    <hr class="m-0 mb-2"/>
      <iframe [src]="googleauthuri" width="100%" height="50px" scrolling="no" frameborder="0"></iframe>
  </div>
</form>

<!-- <div class="modal fade" #registerexistingstudent id="registerexistingstudent" aria-hidden="true" aria-labelledby="registerexistingstudent" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Existing User Found</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p></p>
        <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
          <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn btn--dashed m-auto">Select File</button>
        </form>
      </div>
    </div>
  </div>
</div> -->